import React, { Component } from 'react'
import { MDBContainer, MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBIcon } from 'mdbreact';

export default class LeaderBoard extends Component {
  render() {
    return (
        	<div class="container white_background">
		<div class="row justify-content-center Concepts_intro no-gutters">
			<div class="col-0 col-sm-0 col-md-0 col-lg-4 col-xl-4 Concepts_intro_title_A ">
			    <p class="Concepts_line2">Leader<br />Board</p>
			    <p class="Concepts_line3">(Power28)</p>
			</div>
			<div class="col Concepts_intro_content justify-content-center">
				<div class="row Concepts_intro_brief justify-content-left">
					<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 leaderboard_intro_brief">
					   <p class="Concepts_brief_h">Weekly Leaderboard</p>
					   <p> For every day that you track, you will climb higher on our leaderboard. Try making it to the top! </p>
					   <p class="Concepts_brief_h">Streak<br />Leaderboard</p>
				       <p>Streak Leaderboard shows who has the longest total streak out of everyone using the app!</p>
					</div>
					<div class="col-0 col-sm-0 col-md-0 col-lg-6 col-xl-6">
					   <img src="https://i.ibb.co/smnwmqC/Picture1-3x.png" alt="Picture1-3x" border="0" class="leaderboard_scrsht"/>
					</div>
				</div>
				<div class="row perfect_168 justify-content-center">
					<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-3 perfect_168_title">
						<p>Perfect 168!</p>
					</div>
					<div class="col perfect_168_brief">
						<p>For those of you up to the challenge of tracking every day for 6 months, we encourage you to hit the Perfect168 - the most possible days that you can use the app for the study!</p>
					</div>
				</div>
	    <div class="row">
			<div class="col"></div>
			<div class="col-10 col-sm-9 col-md-8 col-lg-7 col-xl-6">
                <MDBNavLink class="nav-link" to="/badges">
				   <a href="#"  class="Bottom_button_r">
				   <p>What are the badges?</p>
				   </a>
                </MDBNavLink>
            </div>
			<div class="col"></div>
		</div>
			</div>
		</div>
	</div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/LeaderBoard.js